var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25716 10C7.53074 6.06204 8.66753 4.09306 10.1517 3.43227C11.4462 2.85591 12.9245 2.85591 14.219 3.43227C15.7032 4.09306 16.84 6.06204 19.1136 10C21.3871 13.938 22.5239 15.9069 22.3541 17.5226C22.206 18.9319 21.4669 20.2122 20.3204 21.0451C19.0061 22 16.7325 22 12.1854 22C7.63819 22 5.36461 22 4.05028 21.0451C2.90387 20.2122 2.16472 18.9319 2.0166 17.5226C1.84678 15.9069 2.98357 13.938 5.25716 10ZM12.1853 7.25C12.5995 7.25 12.9353 7.58579 12.9353 8V14C12.9353 14.4142 12.5995 14.75 12.1853 14.75C11.7711 14.75 11.4353 14.4142 11.4353 14V8C11.4353 7.58579 11.7711 7.25 12.1853 7.25ZM12.1853 18C12.7376 18 13.1853 17.5523 13.1853 17C13.1853 16.4477 12.7376 16 12.1853 16C11.633 16 11.1853 16.4477 11.1853 17C11.1853 17.5523 11.633 18 12.1853 18Z",
    fill: "#C33F38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertFilled);
export default __webpack_public_path__ + "static/media/AlertFilled.2ee32ce1397095cee02253da594a6df5.svg";
export { ForwardRef as ReactComponent };